import React from "react";
import { Render } from "@measured/puck";
import "@measured/puck/dist/index.css";
import { organizationConfig, eventConfig } from "../../lib/puck/config";
import { IOrganizationProps } from "../../types/Organization";
import { IEventProps, IEventTicketDetailsProps } from "../../types/Event";
import { ISmallEventProps } from "../../types/Event";

interface PuckRendererProps {
  data: any;
  pageType: "organization" | "event";
  organization?: IOrganizationProps | null;
  event?: IEventProps | null;
  events?: ISmallEventProps[];
  tickets?: IEventTicketDetailsProps[];
}

export const PuckRenderer: React.FC<PuckRendererProps> = ({
  data,
  pageType,
  organization,
  event,
  events = [],
  tickets = [],
}) => {
  const config = pageType === "organization" ? organizationConfig : eventConfig;

  const rootProps =
    pageType === "organization"
      ? {
          organization,
          events,
        }
      : {
          event,
          tickets,
        };

  if (!data || !data.content) {
    return null;
  }

  // Merge rootProps into data
  const puckData = {
    ...data,
    root: {
      ...data.root,
      ...rootProps,
    },
  };

  return (
    <div className="min-h-screen">
      <Render config={config} data={puckData} />
    </div>
  );
};

